<template>
  <div class="features container">
    <div class="row">
      <div class="col-md-6 col-ld-4 feature">
        <h4>楽譜読み</h4>
        <p>
          リズムが取りにくい楽譜でも、<br>
          楽譜をそのまま打ち込み再生すれば<br>
          かんたんにリズムがわかります
        </p>
      </div>
      <div class="col-md-6 col-ld-4 feature">
        <h4>メトロノーム</h4>
        <p class="">
          入力したリズムはループ再生されます<br>
          普通のメトロノームではリズムが取りにくいときも<br>
          入力したリズムにあわせて演奏できます
        </p>
      </div>
      <div class="col-md-6 col-ld-4 feature">
        <h4>電卓のような入力</h4>
        <p class="">
          電卓に数字を打ち込むように、ラクラクな入力で<br>
          手軽なリズム再生が可能です
        </p>
      </div>
      <div class="col-md-6 col-ld-4 feature">
        <h4>データの保存・シェア</h4>
        <p class="">
          打ち込んだデータはURLの形で保存できます<br>
          文字では伝えずらいリズムも、友人に送って共有したり<br>
          自分のメモ帳に保存していつでも聞き直せます
        </p>
      </div>
      <!-- <div class="col-md-6 col-ld-4 feature">
        <h4>ダウンロード・登録不要</h4>
        <p class="">
          ウェブサイト型のアプリケーションなので<br>
          スマホでもパソコンでも<br>
          ストアからダウンロードすることなく、すぐに使えます<br>
          一切の登録も必要ありません。
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'features'
}
</script>

<style scoped>
.feature{
  display: block;
  margin: 2rem 0;
  padding: 1rem;
  text-align: left;
}
</style>
